import { Apps } from '../../apps'
import { EInventoryFilterActionTypes, IInventoryFilterState as IInventoryFilterState, InventoryFilterAction } from '../../types/redux/InventoryFilter'
import { EPriceType, EServices, ESortType } from '../../types/tableHelper'

const initialState: IInventoryFilterState = {
	inventoryFilter: {
		appId: Apps.CsGo,
		marketable: false,
		code: 'USD',
		force: false,
		priceType: EPriceType.Normal,
		service: EServices.Steam,
		sortType: ESortType.PriceDesc
	},
	loaded: false,
}

export const inventoryFilterReducer = (state: IInventoryFilterState = initialState, action: InventoryFilterAction): IInventoryFilterState => {
	switch (action.type) {
		case EInventoryFilterActionTypes.SET_INVENTORY_FILTER:
			return { 
                ...state,
                inventoryFilter: action.payload
            }
		default:
			return state
	}
}


